var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "el-row",
        { staticClass: "tac" },
        [
          _c(
            "el-col",
            { attrs: { span: 0 } },
            [
              _c(
                "el-menu",
                { staticClass: "menu-list", attrs: { "default-active": "1" } },
                [
                  _c(
                    "el-menu-item",
                    { attrs: { index: "1" } },
                    [
                      _c("el-icon", [_c("location")], 1),
                      _vm._v(" "),
                      _c(
                        "span",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/autotest/productManager" } },
                            [_vm._v("产品管理")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-menu-item",
                    { attrs: { index: "2" } },
                    [
                      _c("el-icon", [_c("icon-menu")], 1),
                      _vm._v(" "),
                      _c(
                        "span",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/autotest/deviceManager" } },
                            [_vm._v("设备管理")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-menu-item",
                    { attrs: { index: "3" } },
                    [
                      _c("el-icon", [_c("document")], 1),
                      _vm._v(" "),
                      _c(
                        "span",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/autotest/testItemManager" } },
                            [_vm._v("用例管理")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-menu-item",
                    { attrs: { index: "4" } },
                    [
                      _c("el-icon", [_c("setting")], 1),
                      _vm._v(" "),
                      _c(
                        "span",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/autotest/testItemAction" } },
                            [_vm._v("执行测试")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-menu-item", { attrs: { index: "5" } }, [
                    _c(
                      "span",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "el-button el-button-info toshici",
                            attrs: { to: "/shici" },
                          },
                          [_vm._v("诗词")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-menu-item", { attrs: { index: "7" } }, [
                    _c(
                      "span",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "el-button el-button-info toshici",
                            attrs: { to: "/shicigame" },
                          },
                          [_vm._v("诗词游戏")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-menu-item", { attrs: { index: "8" } }, [
                    _c(
                      "span",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "el-button el-button-info toshici",
                            attrs: { to: "/shicifetch" },
                          },
                          [_vm._v("诗词抓取")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-menu-item", { attrs: { index: "9" } }, [
                    _c(
                      "span",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "el-button el-button-info toshici",
                            attrs: { to: "/login" },
                          },
                          [_vm._v("登录")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isAdmin
                    ? _c("el-menu-item", { attrs: { index: "10" } }, [
                        _c(
                          "span",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "el-button el-button-info toshici",
                                attrs: { to: "/manager" },
                              },
                              [_vm._v("后台管理")]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoggedIn
                    ? _c("el-menu-item", { attrs: { index: "11" } }, [
                        _c("span", [
                          _c(
                            "a",
                            {
                              staticClass: "el-button el-button-info toshici",
                              attrs: { href: "javascript:void(0)" },
                              on: { click: _vm.logout },
                            },
                            [_vm._v("退出登录")]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-menu-item", { attrs: { index: "12" } }, [
                    _c(
                      "span",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "el-button el-button-info toshici",
                            attrs: { to: "/biji" },
                          },
                          [_vm._v("笔记")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isAdmin
                    ? _c("el-menu-item", { attrs: { index: "13" } }, [
                        _c(
                          "span",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "el-button el-button-info toshici",
                                attrs: { to: "/bijimng" },
                              },
                              [_vm._v("笔记管理")]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-menu-item", { attrs: { index: "6" } }, [
                    _c(
                      "span",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "el-button el-button-info",
                            attrs: { to: "/debug_yqsl" },
                          },
                          [_vm._v("调试")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-menu-item", { attrs: { index: "6" } }, [
                    _c(
                      "span",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "el-button el-button-info",
                            attrs: { to: "/feitian/feitian" },
                          },
                          [_vm._v("飞天")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-col", [_c("router-view")], 1),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-footer", [
        _c(
          "div",
          { staticClass: "page-bottom" },
          [
            _vm._v("\n        @2019-2026 ICP证："),
            _c("el-link", { attrs: { href: "http://beian.miit.gov.cn/" } }, [
              _vm._v("粤ICP备2026017370号-1"),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("el-divider"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }